module.exports = __webpack_public_path__ + "img/Support-skill-400.393a83f1.png";